import { FunctionComponent } from 'react';
import styles from './TierBadge.module.scss';

type TierBadgeProps = { index: number };

const TierBadge: FunctionComponent<TierBadgeProps> = ({ index }) => (
  <span className={styles.badge}>Tier {index + 1}</span>
);

export default TierBadge;
